module.exports = __webpack_public_path__ + "static/lingui-d6a3ae1754cbffa420f82eae3f6f2ea4.png";